import { StorageHelper, Storages } from '@frontend/profilum-components';

export const pflmLocalStorage = new StorageHelper(Storages.Local);
export const pflmSessionStorage = new StorageHelper(Storages.Session);
export const pflmCookieStorage = new StorageHelper(Storages.Cookie);
